import 'jquery-validation';
import Utils from '../../util/utils';
const ContactForm = {
    _jForm: $('.jsContactForm'),
    _jBookButton: $('#book__meeting'),
    init() {
        this.initValidations();
        this.addEvents();
    },
    initValidations() {
        const me = this;
        if (this._jForm.length > 0) {
            var config = Utils.getValidationConfig({
                ignore: [],
                rules: {
                    name: {
                        required: true,
                        minlength: 2,
                        //spacenotallowed:true,
                    },
                    email: {
                        required: true,
                        customemail: true,
                        // emailNotBanned: true,
                    },

                    message: {
                        required: true,
                        minlength: 2,
                       // addressSpace:true,
                    },

                },
                messages: {
                    name: {
                        required: 'Please provide your Name',
                        minlength: 'Please provide your complete Name',
                    },
                    email: {
                        required: 'Please provide your E-mail',
                        customemail: 'Please provide a valid E-mail',
                    },

                    message: {
                        required: 'Please add your Comment here ',
                        addressSpace : true,
                    },
                },
                submitHandler: function () {
                    me.onFormSubmit();
                },
            });

            this._jForm.validate(config);
        }
    },
    addEvents() {
        if (this._jForm.length > 0) {
            // this._jBookButton.on('click', $.proxy(this.onFormSubmit, this));
        }
    },
    onFormSubmit() {
        if (this._jForm.valid()) {
            var $form = this._jForm;
            var unindexed_array = $form.serializeArray();
            var indexed_array = {};
            jQuery.map(unindexed_array, function (n) {
                indexed_array[n['name']] = n['value'];
            });
            var formData = {};
            formData = indexed_array;
            // formData.form_type = 'ask_us';
            Utils.sendRequest({
                'url': '/wp-admin/admin-ajax.php',
                'data': {
                    'action': 'submitContact',
                    'formData': formData,
                },
                'onDone': $.proxy(this._onSuccess, this),
            });
        }
        return false;
    },
    _onSuccess(response) {
        this._jForm[0].reset();
        Utils.showLoader(false);
        Utils.notify({
            'message': response.message,
        });
    },

}
export default ContactForm;



// WEBPACK FOOTER //
// ./scripts/modules/forms/contact.js